import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const EndocrineAndrogensDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const hsd3b1 = getGenePalette(geneColors.HSD3B1);
  const cyp17a1 = getGenePalette(geneColors.CYP17A1);
  const cyp19a1 = getGenePalette(geneColors.CYP19A1);
  const shbg = getGenePalette(geneColors.SHBG);
  const ar = getGenePalette(geneColors.AR);
  const srd5a1 = getGenePalette(geneColors.SRD5A1);
  const srd5a2 = getGenePalette(geneColors.SRD5A2);
  const ugt2b15 = getGenePalette(geneColors.UGT2B15);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_224294)">
        <rect width={1540} height={895} transform="translate(0 204)" fill="white" />
        <g id="androgens-diagram">
          <rect width={1540} height={922} transform="translate(0 204)" fill="white" />
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M416.041 607L420.082 600L412 600L416.041 607ZM416.741 473.7L416.741 473L415.341 473L415.341 473.7L416.041 473.7L416.741 473.7ZM416.041 600.7L416.741 600.7L416.741 473.7L416.041 473.7L415.341 473.7L415.341 600.7L416.041 600.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M810.041 440L814.082 433L806 433L810.041 440ZM810.741 293.7L810.741 293L809.341 293L809.341 293.7L810.041 293.7L810.741 293.7ZM810.041 433.7L810.741 433.7L810.741 293.7L810.041 293.7L809.341 293.7L809.341 433.7L810.041 433.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M810.041 517L814.082 510L806 510L810.041 517ZM810.741 472.7L810.741 472L809.341 472L809.341 472.7L810.041 472.7L810.741 472.7ZM810.041 510.7L810.741 510.7L810.741 472.7L810.041 472.7L809.341 472.7L809.341 510.7L810.041 510.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M961 453.042L954 449L954 457.083L961 453.042ZM853.7 452.342L853 452.342L853 453.742L853.7 453.742L853.7 453.042L853.7 452.342ZM954.7 453.042L954.7 452.342L853.7 452.342L853.7 453.042L853.7 453.742L954.7 453.742L954.7 453.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_7"
              d="M1397.3 625.7L884.7 625.7"
              stroke="#818181"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M1379.3 697.7L1002.7 697.7"
              stroke="#818181"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M1001.91 698.192L839.986 834.061"
              stroke="#818181"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_10"
              d="M1398.74 626.7C1398.74 626.314 1398.43 626 1398.04 626C1397.66 626 1397.34 626.314 1397.34 626.7L1398.04 626.7L1398.74 626.7ZM1398.04 746L1402.08 739L1394 739L1398.04 746ZM1397.34 628.689C1397.34 629.075 1397.66 629.389 1398.04 629.389C1398.43 629.389 1398.74 629.075 1398.74 628.689L1398.04 628.689L1397.34 628.689ZM1398.74 632.665C1398.74 632.279 1398.43 631.965 1398.04 631.965C1397.66 631.965 1397.34 632.279 1397.34 632.665L1398.04 632.665L1398.74 632.665ZM1397.34 636.642C1397.34 637.028 1397.66 637.342 1398.04 637.342C1398.43 637.342 1398.74 637.028 1398.74 636.642L1398.04 636.642L1397.34 636.642ZM1398.74 640.619C1398.74 640.232 1398.43 639.919 1398.04 639.919C1397.66 639.919 1397.34 640.232 1397.34 640.619L1398.04 640.619L1398.74 640.619ZM1397.34 644.595C1397.34 644.982 1397.66 645.295 1398.04 645.295C1398.43 645.295 1398.74 644.982 1398.74 644.595L1398.04 644.595L1397.34 644.595ZM1398.74 648.572C1398.74 648.185 1398.43 647.872 1398.04 647.872C1397.66 647.872 1397.34 648.185 1397.34 648.572L1398.04 648.572L1398.74 648.572ZM1397.34 652.549C1397.34 652.935 1397.66 653.249 1398.04 653.249C1398.43 653.249 1398.74 652.935 1398.74 652.549L1398.04 652.549L1397.34 652.549ZM1398.74 656.525C1398.74 656.139 1398.43 655.825 1398.04 655.825C1397.66 655.825 1397.34 656.139 1397.34 656.525L1398.04 656.525L1398.74 656.525ZM1397.34 660.502C1397.34 660.888 1397.66 661.202 1398.04 661.202C1398.43 661.202 1398.74 660.888 1398.74 660.502L1398.04 660.502L1397.34 660.502ZM1398.74 664.479C1398.74 664.092 1398.43 663.779 1398.04 663.779C1397.66 663.779 1397.34 664.092 1397.34 664.479L1398.04 664.479L1398.74 664.479ZM1397.34 668.455C1397.34 668.842 1397.66 669.155 1398.04 669.155C1398.43 669.155 1398.74 668.842 1398.74 668.455L1398.04 668.455L1397.34 668.455ZM1398.74 672.432C1398.74 672.045 1398.43 671.732 1398.04 671.732C1397.66 671.732 1397.34 672.045 1397.34 672.432L1398.04 672.432L1398.74 672.432ZM1397.34 676.409C1397.34 676.795 1397.66 677.109 1398.04 677.109C1398.43 677.109 1398.74 676.795 1398.74 676.409L1398.04 676.409L1397.34 676.409ZM1398.74 680.385C1398.74 679.999 1398.43 679.685 1398.04 679.685C1397.66 679.685 1397.34 679.999 1397.34 680.385L1398.04 680.385L1398.74 680.385ZM1397.34 684.362C1397.34 684.748 1397.66 685.062 1398.04 685.062C1398.43 685.062 1398.74 684.748 1398.74 684.362L1398.04 684.362L1397.34 684.362ZM1398.74 688.339C1398.74 687.952 1398.43 687.639 1398.04 687.639C1397.66 687.639 1397.34 687.952 1397.34 688.339L1398.04 688.339L1398.74 688.339ZM1397.34 692.315C1397.34 692.702 1397.66 693.015 1398.04 693.015C1398.43 693.015 1398.74 692.702 1398.74 692.315L1398.04 692.315L1397.34 692.315ZM1398.74 696.292C1398.74 695.905 1398.43 695.592 1398.04 695.592C1397.66 695.592 1397.34 695.905 1397.34 696.292L1398.04 696.292L1398.74 696.292ZM1397.34 700.269C1397.34 700.655 1397.66 700.969 1398.04 700.969C1398.43 700.969 1398.74 700.655 1398.74 700.269L1398.04 700.269L1397.34 700.269ZM1398.74 704.245C1398.74 703.859 1398.43 703.545 1398.04 703.545C1397.66 703.545 1397.34 703.859 1397.34 704.245L1398.04 704.245L1398.74 704.245ZM1397.34 708.222C1397.34 708.608 1397.66 708.922 1398.04 708.922C1398.43 708.922 1398.74 708.608 1398.74 708.222L1398.04 708.222L1397.34 708.222ZM1398.74 712.199C1398.74 711.812 1398.43 711.499 1398.04 711.499C1397.66 711.499 1397.34 711.812 1397.34 712.199L1398.04 712.199L1398.74 712.199ZM1397.34 716.175C1397.34 716.562 1397.66 716.875 1398.04 716.875C1398.43 716.875 1398.74 716.562 1398.74 716.175L1398.04 716.175L1397.34 716.175ZM1398.74 720.152C1398.74 719.765 1398.43 719.452 1398.04 719.452C1397.66 719.452 1397.34 719.765 1397.34 720.152L1398.04 720.152L1398.74 720.152ZM1397.34 724.129C1397.34 724.515 1397.66 724.829 1398.04 724.829C1398.43 724.829 1398.74 724.515 1398.74 724.129L1398.04 724.129L1397.34 724.129ZM1398.74 728.105C1398.74 727.719 1398.43 727.405 1398.04 727.405C1397.66 727.405 1397.34 727.719 1397.34 728.105L1398.04 728.105L1398.74 728.105ZM1397.34 732.082C1397.34 732.468 1397.66 732.782 1398.04 732.782C1398.43 732.782 1398.74 732.468 1398.74 732.082L1398.04 732.082L1397.34 732.082ZM1398.74 736.059C1398.74 735.672 1398.43 735.359 1398.04 735.359C1397.66 735.359 1397.34 735.672 1397.34 736.059L1398.04 736.059L1398.74 736.059ZM1397.34 740.035C1397.34 740.422 1397.66 740.735 1398.04 740.735C1398.43 740.735 1398.74 740.422 1398.74 740.035L1398.04 740.035L1397.34 740.035ZM1398.74 744.012C1398.74 743.625 1398.43 743.312 1398.04 743.312C1397.66 743.312 1397.34 743.625 1397.34 744.012L1398.04 744.012L1398.74 744.012ZM1398.04 626.7L1397.34 626.7L1397.34 628.689L1398.04 628.689L1398.74 628.689L1398.74 626.7L1398.04 626.7ZM1398.04 632.665L1397.34 632.665L1397.34 636.642L1398.04 636.642L1398.74 636.642L1398.74 632.665L1398.04 632.665ZM1398.04 640.619L1397.34 640.619L1397.34 644.595L1398.04 644.595L1398.74 644.595L1398.74 640.619L1398.04 640.619ZM1398.04 648.572L1397.34 648.572L1397.34 652.549L1398.04 652.549L1398.74 652.549L1398.74 648.572L1398.04 648.572ZM1398.04 656.525L1397.34 656.525L1397.34 660.502L1398.04 660.502L1398.74 660.502L1398.74 656.525L1398.04 656.525ZM1398.04 664.479L1397.34 664.479L1397.34 668.455L1398.04 668.455L1398.74 668.455L1398.74 664.479L1398.04 664.479ZM1398.04 672.432L1397.34 672.432L1397.34 676.409L1398.04 676.409L1398.74 676.409L1398.74 672.432L1398.04 672.432ZM1398.04 680.385L1397.34 680.385L1397.34 684.362L1398.04 684.362L1398.74 684.362L1398.74 680.385L1398.04 680.385ZM1398.04 688.339L1397.34 688.339L1397.34 692.315L1398.04 692.315L1398.74 692.315L1398.74 688.339L1398.04 688.339ZM1398.04 696.292L1397.34 696.292L1397.34 700.269L1398.04 700.269L1398.74 700.269L1398.74 696.292L1398.04 696.292ZM1398.04 704.245L1397.34 704.245L1397.34 708.222L1398.04 708.222L1398.74 708.222L1398.74 704.245L1398.04 704.245ZM1398.04 712.199L1397.34 712.199L1397.34 716.175L1398.04 716.175L1398.74 716.175L1398.74 712.199L1398.04 712.199ZM1398.04 720.152L1397.34 720.152L1397.34 724.129L1398.04 724.129L1398.74 724.129L1398.74 720.152L1398.04 720.152ZM1398.04 728.105L1397.34 728.105L1397.34 732.082L1398.04 732.082L1398.74 732.082L1398.74 728.105L1398.04 728.105ZM1398.04 736.059L1397.34 736.059L1397.34 740.035L1398.04 740.035L1398.74 740.035L1398.74 736.059L1398.04 736.059Z"
              fill="#818181"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_11"
              d="M1393.74 774.7L1393.74 774L1392.34 774L1392.34 774.7L1393.04 774.7L1393.74 774.7ZM1393.04 894L1397.08 887L1389 887L1393.04 894ZM1393.04 774.7L1392.34 774.7L1392.34 887.7L1393.04 887.7L1393.74 887.7L1393.74 774.7L1393.04 774.7Z"
              fill="#282828"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_12"
              d="M1219.74 769.7L1219.74 769L1218.34 769L1218.34 769.7L1219.04 769.7L1219.74 769.7ZM1219.04 889L1223.08 882L1215 882L1219.04 889ZM1219.04 769.7L1218.34 769.7L1218.34 882.7L1219.04 882.7L1219.74 882.7L1219.74 769.7L1219.04 769.7Z"
              fill="#282828"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_13"
              d="M1231.74 626.7C1231.74 626.314 1231.43 626 1231.04 626C1230.66 626 1230.34 626.314 1230.34 626.7L1231.04 626.7L1231.74 626.7ZM1231.04 746L1235.08 739L1227 739L1231.04 746ZM1230.34 628.689C1230.34 629.075 1230.66 629.389 1231.04 629.389C1231.43 629.389 1231.74 629.075 1231.74 628.689L1231.04 628.689L1230.34 628.689ZM1231.74 632.665C1231.74 632.279 1231.43 631.965 1231.04 631.965C1230.66 631.965 1230.34 632.279 1230.34 632.665L1231.04 632.665L1231.74 632.665ZM1230.34 636.642C1230.34 637.028 1230.66 637.342 1231.04 637.342C1231.43 637.342 1231.74 637.028 1231.74 636.642L1231.04 636.642L1230.34 636.642ZM1231.74 640.619C1231.74 640.232 1231.43 639.919 1231.04 639.919C1230.66 639.919 1230.34 640.232 1230.34 640.619L1231.04 640.619L1231.74 640.619ZM1230.34 644.595C1230.34 644.982 1230.66 645.295 1231.04 645.295C1231.43 645.295 1231.74 644.982 1231.74 644.595L1231.04 644.595L1230.34 644.595ZM1231.74 648.572C1231.74 648.185 1231.43 647.872 1231.04 647.872C1230.66 647.872 1230.34 648.185 1230.34 648.572L1231.04 648.572L1231.74 648.572ZM1230.34 652.549C1230.34 652.935 1230.66 653.249 1231.04 653.249C1231.43 653.249 1231.74 652.935 1231.74 652.549L1231.04 652.549L1230.34 652.549ZM1231.74 656.525C1231.74 656.139 1231.43 655.825 1231.04 655.825C1230.66 655.825 1230.34 656.139 1230.34 656.525L1231.04 656.525L1231.74 656.525ZM1230.34 660.502C1230.34 660.888 1230.66 661.202 1231.04 661.202C1231.43 661.202 1231.74 660.888 1231.74 660.502L1231.04 660.502L1230.34 660.502ZM1231.74 664.479C1231.74 664.092 1231.43 663.779 1231.04 663.779C1230.66 663.779 1230.34 664.092 1230.34 664.479L1231.04 664.479L1231.74 664.479ZM1230.34 668.455C1230.34 668.842 1230.66 669.155 1231.04 669.155C1231.43 669.155 1231.74 668.842 1231.74 668.455L1231.04 668.455L1230.34 668.455ZM1231.74 672.432C1231.74 672.045 1231.43 671.732 1231.04 671.732C1230.66 671.732 1230.34 672.045 1230.34 672.432L1231.04 672.432L1231.74 672.432ZM1230.34 676.409C1230.34 676.795 1230.66 677.109 1231.04 677.109C1231.43 677.109 1231.74 676.795 1231.74 676.409L1231.04 676.409L1230.34 676.409ZM1231.74 680.385C1231.74 679.999 1231.43 679.685 1231.04 679.685C1230.66 679.685 1230.34 679.999 1230.34 680.385L1231.04 680.385L1231.74 680.385ZM1230.34 684.362C1230.34 684.748 1230.66 685.062 1231.04 685.062C1231.43 685.062 1231.74 684.748 1231.74 684.362L1231.04 684.362L1230.34 684.362ZM1231.74 688.339C1231.74 687.952 1231.43 687.639 1231.04 687.639C1230.66 687.639 1230.34 687.952 1230.34 688.339L1231.04 688.339L1231.74 688.339ZM1230.34 692.315C1230.34 692.702 1230.66 693.015 1231.04 693.015C1231.43 693.015 1231.74 692.702 1231.74 692.315L1231.04 692.315L1230.34 692.315ZM1231.74 696.292C1231.74 695.905 1231.43 695.592 1231.04 695.592C1230.66 695.592 1230.34 695.905 1230.34 696.292L1231.04 696.292L1231.74 696.292ZM1230.34 700.269C1230.34 700.655 1230.66 700.969 1231.04 700.969C1231.43 700.969 1231.74 700.655 1231.74 700.269L1231.04 700.269L1230.34 700.269ZM1231.74 704.245C1231.74 703.859 1231.43 703.545 1231.04 703.545C1230.66 703.545 1230.34 703.859 1230.34 704.245L1231.04 704.245L1231.74 704.245ZM1230.34 708.222C1230.34 708.608 1230.66 708.922 1231.04 708.922C1231.43 708.922 1231.74 708.608 1231.74 708.222L1231.04 708.222L1230.34 708.222ZM1231.74 712.199C1231.74 711.812 1231.43 711.499 1231.04 711.499C1230.66 711.499 1230.34 711.812 1230.34 712.199L1231.04 712.199L1231.74 712.199ZM1230.34 716.175C1230.34 716.562 1230.66 716.875 1231.04 716.875C1231.43 716.875 1231.74 716.562 1231.74 716.175L1231.04 716.175L1230.34 716.175ZM1231.74 720.152C1231.74 719.765 1231.43 719.452 1231.04 719.452C1230.66 719.452 1230.34 719.765 1230.34 720.152L1231.04 720.152L1231.74 720.152ZM1230.34 724.129C1230.34 724.515 1230.66 724.829 1231.04 724.829C1231.43 724.829 1231.74 724.515 1231.74 724.129L1231.04 724.129L1230.34 724.129ZM1231.74 728.105C1231.74 727.719 1231.43 727.405 1231.04 727.405C1230.66 727.405 1230.34 727.719 1230.34 728.105L1231.04 728.105L1231.74 728.105ZM1230.34 732.082C1230.34 732.468 1230.66 732.782 1231.04 732.782C1231.43 732.782 1231.74 732.468 1231.74 732.082L1231.04 732.082L1230.34 732.082ZM1231.74 736.059C1231.74 735.672 1231.43 735.359 1231.04 735.359C1230.66 735.359 1230.34 735.672 1230.34 736.059L1231.04 736.059L1231.74 736.059ZM1230.34 740.035C1230.34 740.422 1230.66 740.735 1231.04 740.735C1231.43 740.735 1231.74 740.422 1231.74 740.035L1231.04 740.035L1230.34 740.035ZM1231.74 744.012C1231.74 743.625 1231.43 743.312 1231.04 743.312C1230.66 743.312 1230.34 743.625 1230.34 744.012L1231.04 744.012L1231.74 744.012ZM1231.04 626.7L1230.34 626.7L1230.34 628.689L1231.04 628.689L1231.74 628.689L1231.74 626.7L1231.04 626.7ZM1231.04 632.665L1230.34 632.665L1230.34 636.642L1231.04 636.642L1231.74 636.642L1231.74 632.665L1231.04 632.665ZM1231.04 640.619L1230.34 640.619L1230.34 644.595L1231.04 644.595L1231.74 644.595L1231.74 640.619L1231.04 640.619ZM1231.04 648.572L1230.34 648.572L1230.34 652.549L1231.04 652.549L1231.74 652.549L1231.74 648.572L1231.04 648.572ZM1231.04 656.525L1230.34 656.525L1230.34 660.502L1231.04 660.502L1231.74 660.502L1231.74 656.525L1231.04 656.525ZM1231.04 664.479L1230.34 664.479L1230.34 668.455L1231.04 668.455L1231.74 668.455L1231.74 664.479L1231.04 664.479ZM1231.04 672.432L1230.34 672.432L1230.34 676.409L1231.04 676.409L1231.74 676.409L1231.74 672.432L1231.04 672.432ZM1231.04 680.385L1230.34 680.385L1230.34 684.362L1231.04 684.362L1231.74 684.362L1231.74 680.385L1231.04 680.385ZM1231.04 688.339L1230.34 688.339L1230.34 692.315L1231.04 692.315L1231.74 692.315L1231.74 688.339L1231.04 688.339ZM1231.04 696.292L1230.34 696.292L1230.34 700.269L1231.04 700.269L1231.74 700.269L1231.74 696.292L1231.04 696.292ZM1231.04 704.245L1230.34 704.245L1230.34 708.222L1231.04 708.222L1231.74 708.222L1231.74 704.245L1231.04 704.245ZM1231.04 712.199L1230.34 712.199L1230.34 716.175L1231.04 716.175L1231.74 716.175L1231.74 712.199L1231.04 712.199ZM1231.04 720.152L1230.34 720.152L1230.34 724.129L1231.04 724.129L1231.74 724.129L1231.74 720.152L1231.04 720.152ZM1231.04 728.105L1230.34 728.105L1230.34 732.082L1231.04 732.082L1231.74 732.082L1231.74 728.105L1231.04 728.105ZM1231.04 736.059L1230.34 736.059L1230.34 740.035L1231.04 740.035L1231.74 740.035L1231.74 736.059L1231.04 736.059Z"
              fill="#818181"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_14"
              d="M1215.74 698.7C1215.74 698.314 1215.43 698 1215.04 698C1214.66 698 1214.34 698.314 1214.34 698.7L1215.04 698.7L1215.74 698.7ZM1215.04 746L1219.08 739L1211 739L1215.04 746ZM1214.34 700.671C1214.34 701.058 1214.66 701.371 1215.04 701.371C1215.43 701.371 1215.74 701.058 1215.74 700.671L1215.04 700.671L1214.34 700.671ZM1215.74 704.613C1215.74 704.226 1215.43 703.913 1215.04 703.913C1214.66 703.913 1214.34 704.226 1214.34 704.613L1215.04 704.613L1215.74 704.613ZM1214.34 708.554C1214.34 708.941 1214.66 709.254 1215.04 709.254C1215.43 709.254 1215.74 708.941 1215.74 708.554L1215.04 708.554L1214.34 708.554ZM1215.74 712.496C1215.74 712.109 1215.43 711.796 1215.04 711.796C1214.66 711.796 1214.34 712.109 1214.34 712.496L1215.04 712.496L1215.74 712.496ZM1214.34 716.438C1214.34 716.824 1214.66 717.138 1215.04 717.138C1215.43 717.138 1215.74 716.824 1215.74 716.438L1215.04 716.438L1214.34 716.438ZM1215.74 720.379C1215.74 719.993 1215.43 719.679 1215.04 719.679C1214.66 719.679 1214.34 719.993 1214.34 720.379L1215.04 720.379L1215.74 720.379ZM1214.34 724.321C1214.34 724.708 1214.66 725.021 1215.04 725.021C1215.43 725.021 1215.74 724.708 1215.74 724.321L1215.04 724.321L1214.34 724.321ZM1215.74 728.263C1215.74 727.876 1215.43 727.563 1215.04 727.563C1214.66 727.563 1214.34 727.876 1214.34 728.263L1215.04 728.263L1215.74 728.263ZM1214.34 732.204C1214.34 732.591 1214.66 732.904 1215.04 732.904C1215.43 732.904 1215.74 732.591 1215.74 732.204L1215.04 732.204L1214.34 732.204ZM1215.74 736.146C1215.74 735.759 1215.43 735.446 1215.04 735.446C1214.66 735.446 1214.34 735.759 1214.34 736.146L1215.04 736.146L1215.74 736.146ZM1214.34 740.088C1214.34 740.474 1214.66 740.788 1215.04 740.788C1215.43 740.788 1215.74 740.474 1215.74 740.088L1215.04 740.088L1214.34 740.088ZM1215.74 744.029C1215.74 743.643 1215.43 743.329 1215.04 743.329C1214.66 743.329 1214.34 743.643 1214.34 744.029L1215.04 744.029L1215.74 744.029ZM1215.04 698.7L1214.34 698.7L1214.34 700.671L1215.04 700.671L1215.74 700.671L1215.74 698.7L1215.04 698.7ZM1215.04 704.613L1214.34 704.613L1214.34 708.554L1215.04 708.554L1215.74 708.554L1215.74 704.613L1215.04 704.613ZM1215.04 712.496L1214.34 712.496L1214.34 716.438L1215.04 716.438L1215.74 716.438L1215.74 712.496L1215.04 712.496ZM1215.04 720.379L1214.34 720.379L1214.34 724.321L1215.04 724.321L1215.74 724.321L1215.74 720.379L1215.04 720.379ZM1215.04 728.263L1214.34 728.263L1214.34 732.204L1215.04 732.204L1215.74 732.204L1215.74 728.263L1215.04 728.263ZM1215.04 736.146L1214.34 736.146L1214.34 740.088L1215.04 740.088L1215.74 740.088L1215.74 736.146L1215.04 736.146Z"
              fill="#818181"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_15"
              d="M1381.74 698.7C1381.74 698.314 1381.43 698 1381.04 698C1380.66 698 1380.34 698.314 1380.34 698.7L1381.04 698.7L1381.74 698.7ZM1381.04 746L1385.08 739L1377 739L1381.04 746ZM1380.34 700.671C1380.34 701.058 1380.66 701.371 1381.04 701.371C1381.43 701.371 1381.74 701.058 1381.74 700.671L1381.04 700.671L1380.34 700.671ZM1381.74 704.613C1381.74 704.226 1381.43 703.913 1381.04 703.913C1380.66 703.913 1380.34 704.226 1380.34 704.613L1381.04 704.613L1381.74 704.613ZM1380.34 708.554C1380.34 708.941 1380.66 709.254 1381.04 709.254C1381.43 709.254 1381.74 708.941 1381.74 708.554L1381.04 708.554L1380.34 708.554ZM1381.74 712.496C1381.74 712.109 1381.43 711.796 1381.04 711.796C1380.66 711.796 1380.34 712.109 1380.34 712.496L1381.04 712.496L1381.74 712.496ZM1380.34 716.438C1380.34 716.824 1380.66 717.138 1381.04 717.138C1381.43 717.138 1381.74 716.824 1381.74 716.438L1381.04 716.438L1380.34 716.438ZM1381.74 720.379C1381.74 719.993 1381.43 719.679 1381.04 719.679C1380.66 719.679 1380.34 719.993 1380.34 720.379L1381.04 720.379L1381.74 720.379ZM1380.34 724.321C1380.34 724.708 1380.66 725.021 1381.04 725.021C1381.43 725.021 1381.74 724.708 1381.74 724.321L1381.04 724.321L1380.34 724.321ZM1381.74 728.263C1381.74 727.876 1381.43 727.563 1381.04 727.563C1380.66 727.563 1380.34 727.876 1380.34 728.263L1381.04 728.263L1381.74 728.263ZM1380.34 732.204C1380.34 732.591 1380.66 732.904 1381.04 732.904C1381.43 732.904 1381.74 732.591 1381.74 732.204L1381.04 732.204L1380.34 732.204ZM1381.74 736.146C1381.74 735.759 1381.43 735.446 1381.04 735.446C1380.66 735.446 1380.34 735.759 1380.34 736.146L1381.04 736.146L1381.74 736.146ZM1380.34 740.088C1380.34 740.474 1380.66 740.788 1381.04 740.788C1381.43 740.788 1381.74 740.474 1381.74 740.088L1381.04 740.088L1380.34 740.088ZM1381.74 744.029C1381.74 743.643 1381.43 743.329 1381.04 743.329C1380.66 743.329 1380.34 743.643 1380.34 744.029L1381.04 744.029L1381.74 744.029ZM1381.04 698.7L1380.34 698.7L1380.34 700.671L1381.04 700.671L1381.74 700.671L1381.74 698.7L1381.04 698.7ZM1381.04 704.613L1380.34 704.613L1380.34 708.554L1381.04 708.554L1381.74 708.554L1381.74 704.613L1381.04 704.613ZM1381.04 712.496L1380.34 712.496L1380.34 716.438L1381.04 716.438L1381.74 716.438L1381.74 712.496L1381.04 712.496ZM1381.04 720.379L1380.34 720.379L1380.34 724.321L1381.04 724.321L1381.74 724.321L1381.74 720.379L1381.04 720.379ZM1381.04 728.263L1380.34 728.263L1380.34 732.204L1381.04 732.204L1381.74 732.204L1381.74 728.263L1381.04 728.263ZM1381.04 736.146L1380.34 736.146L1380.34 740.088L1381.04 740.088L1381.74 740.088L1381.74 736.146L1381.04 736.146Z"
              fill="#818181"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_16"
              d="M1009.28 840.601L1008.57 832.549L1001.95 837.195L1009.28 840.601ZM870.282 641.494L869.88 640.921L868.734 641.726L869.136 642.298L869.709 641.896L870.282 641.494ZM1005.66 835.445L1006.23 835.043L870.282 641.494L869.709 641.896L869.136 642.298L1005.09 835.848L1005.66 835.445Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_17"
              d="M754 831.042L747 827L747 835.083L754 831.042ZM646.7 830.342L646 830.342L646 831.742L646.7 831.742L646.7 831.042L646.7 830.342ZM747.7 831.042L747.7 830.342L646.7 830.342L646.7 831.042L646.7 831.742L747.7 831.742L747.7 831.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_18"
              d="M988 1063.04L981 1059L981 1067.08L988 1063.04ZM628.7 1062.34L628 1062.34L628 1063.74L628.7 1063.74L628.7 1063.04L628.7 1062.34ZM981.7 1063.04L981.7 1062.34L628.7 1062.34L628.7 1063.04L628.7 1063.74L981.7 1063.74L981.7 1063.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_19"
              d="M960.3 470.742L961 470.742L961 469.342L960.3 469.342L960.3 470.042L960.3 470.742ZM853 470.042L860 474.083L860 466L853 470.042ZM960.3 470.042L960.3 469.342L859.3 469.342L859.3 470.042L859.3 470.742L960.3 470.742L960.3 470.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_19">
            <path
              id="Vector_20"
              d="M753.3 848.742L754 848.742L754 847.342L753.3 847.342L753.3 848.042L753.3 848.742ZM646 848.042L653 852.083L653 844L646 848.042ZM753.3 848.042L753.3 847.342L652.3 847.342L652.3 848.042L652.3 848.742L753.3 848.742L753.3 848.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_21"
              d="M987.3 1080.74L988 1080.74L988 1079.34L987.3 1079.34L987.3 1080.04L987.3 1080.74ZM628 1080.04L635 1084.08L635 1076L628 1080.04ZM987.3 1080.04L987.3 1079.34L634.3 1079.34L634.3 1080.04L634.3 1080.74L987.3 1080.74L987.3 1080.04Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_21">
            <path
              id="Vector_22"
              d="M810.041 607L814.082 600L806 600L810.041 607ZM810.741 565.7L810.741 565L809.341 565L809.341 565.7L810.041 565.7L810.741 565.7ZM810.041 600.7L810.741 600.7L810.741 565.7L810.041 565.7L809.341 565.7L809.341 600.7L810.041 600.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_22">
            <path
              id="Vector_23"
              d="M810.041 817L814.082 810L806 810L810.041 817ZM810.741 634.7L810.741 634L809.341 634L809.341 634.7L810.041 634.7L810.741 634.7ZM810.041 810.7L810.741 810.7L810.741 634.7L810.041 634.7L809.341 634.7L809.341 810.7L810.041 810.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_23">
            <path
              id="Vector_24"
              d="M810.041 881L814.082 874L806 874L810.041 881ZM810.741 848.7L810.741 848L809.341 848L809.341 848.7L810.041 848.7L810.741 848.7ZM810.041 874.7L810.741 874.7L810.741 848.7L810.041 848.7L809.341 848.7L809.341 874.7L810.041 874.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_24">
            <path
              id="Vector_25"
              d="M810.041 1003L814.082 996L806 996L810.041 1003ZM810.741 913.7L810.741 913L809.341 913L809.341 913.7L810.041 913.7L810.741 913.7ZM810.041 996.7L810.741 996.7L810.741 913.7L810.041 913.7L809.341 913.7L809.341 996.7L810.041 996.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_25">
            <path
              id="Vector_26"
              d="M550.041 817L554.082 810L546 810L550.041 817ZM550.741 703.7L550.741 703L549.341 703L549.341 703.7L550.041 703.7L550.741 703.7ZM550.041 810.7L550.741 810.7L550.741 703.7L550.041 703.7L549.341 703.7L549.341 810.7L550.041 810.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_26">
            <path
              id="Vector_27"
              d="M391.303 438.368L387.887 431.043L383.251 437.664L391.303 438.368ZM337.755 400.019L337.182 399.618L336.379 400.765L336.952 401.166L337.354 400.593L337.755 400.019ZM386.142 434.755L386.544 434.181L337.755 400.019L337.354 400.593L336.952 401.166L385.741 435.328L386.142 434.755Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_27">
            <path
              id="Vector_28"
              d="M583.567 1061.42L580.151 1054.09L575.515 1060.71L583.567 1061.42ZM427.294 951.139L426.72 950.737L425.917 951.884L426.491 952.286L426.892 951.712L427.294 951.139ZM578.407 1057.8L578.808 1057.23L427.294 951.139L426.892 951.712L426.491 952.286L578.005 1058.38L578.407 1057.8Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_28">
            <path
              id="Vector_29"
              d="M575.645 693.86L492.975 635.975"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_29">
            <path
              id="Vector_30"
              d="M440.318 438.368L443.734 431.043L448.371 437.664L440.318 438.368ZM493.866 400.019L494.439 399.618L495.242 400.765L494.669 401.166L494.267 400.593L493.866 400.019ZM445.479 434.755L445.078 434.181L493.866 400.019L494.267 400.593L494.669 401.166L445.881 435.328L445.479 434.755Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_30">
            <path
              id="Vector_31"
              d="M275.159 336.449L267.079 336.668L270.93 329.561L275.159 336.449ZM161.207 275.502L160.591 275.169L161.258 273.938L161.874 274.271L161.54 274.887L161.207 275.502ZM269.62 333.448L269.287 334.063L161.207 275.502L161.54 274.887L161.874 274.271L269.953 332.832L269.62 333.448Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_31">
            <path
              id="Vector_32"
              d="M605.926 337.371L614.006 337.589L610.155 330.482L605.926 337.371ZM719.878 276.424L720.494 276.09L719.827 274.859L719.211 275.193L719.545 275.808L719.878 276.424ZM611.465 334.369L611.798 334.985L719.878 276.424L719.545 275.808L719.211 275.193L611.131 333.754L611.465 334.369Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_32">
            <path
              id="Vector_33"
              d="M493.812 614.873L501.892 615.092L498.042 607.985L493.812 614.873ZM783.879 458.502L784.494 458.169L783.827 456.938L783.212 457.271L783.545 457.887L783.879 458.502ZM499.352 611.872L499.685 612.487L783.879 458.502L783.545 457.887L783.212 457.271L499.018 611.256L499.352 611.872Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_33">
            <path
              id="Vector_34"
              d="M416.041 881L420.082 874L412 874L416.041 881ZM416.741 641.7L416.741 641L415.341 641L415.341 641.7L416.041 641.7L416.741 641.7ZM416.041 874.7L416.741 874.7L416.741 641.7L416.041 641.7L415.341 641.7L415.341 874.7L416.041 874.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_34">
            <path
              id="Vector_35"
              d="M1005.04 1040L1009.08 1033L1001 1033L1005.04 1040ZM1005.74 914.7L1005.74 914L1004.34 914L1004.34 914.7L1005.04 914.7L1005.74 914.7ZM1005.04 1033.7L1005.74 1033.7L1005.74 914.7L1005.04 914.7L1004.34 914.7L1004.34 1033.7L1005.04 1033.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={151} height={28} transform="translate(736 260)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={736.039} y={279.448}>
                17-OH Pregnenolone
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={98} height={28} transform="translate(47 254)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={47.2109} y={273.448}>
                Progesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={147} height={28} transform="translate(347 440)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={347.266} y={459.448}>
                17-OH Progesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={126} height={28} transform="translate(353 615)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={353.195} y={634.448}>
                Androstenedione
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={111} height={28} transform="translate(754 521)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={754.117} y={540.448}>
                Androstenediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={42} height={28} transform="translate(791 445)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={791.305} y={464.464}>
                DHEA
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={42} height={28} transform="translate(1198 751)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={1197.93} y={770.464}>
                SHBG
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={42} height={28} transform="translate(1369 751)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={1379.97} y={770.448}>
                AR
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={95} height={28} transform="translate(762 611)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={762.477} y={630.464}>
                Testosterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={31} height={28} transform="translate(794 822)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={794.039} y={841.448}>
                DHT
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={15} height={28} transform="translate(597 1049)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={597.383} y={1068.45}>
                E1
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <rect width={17} height={28} transform="translate(1001 1049)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={1001.04} y={1068.45}>
                E2
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={141} height={20} transform="translate(739 886)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={739.41} y={900.086}>
                {"3\u03B1-Diols (Androstanediol)"}
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={176} height={20} transform="translate(722 1008)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={722.285} y={1022.09}>
                Detoxification (Glucuronidation)
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <rect width={136} height={68} transform="translate(1326 894)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_15"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="-0.02em"
            >
              <tspan x={1338.87} y={908.086}>
                {"Bound hormones are "}
              </tspan>
              <tspan x={1333.98} y={924.086}>
                {"transported to nucleus "}
              </tspan>
              <tspan x={1326.22} y={940.086}>
                {"where they bind DNA and "}
              </tspan>
              <tspan x={1335.68} y={956.086}>
                regulate gene activity
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <rect width={122} height={36} transform="translate(1154 893)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_16"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="-0.02em"
            >
              <tspan x={1154.48} y={907.086}>
                {"Biologically inactivates "}
              </tspan>
              <tspan x={1158.33} y={923.086}>
                hormones bound to it
              </tspan>
            </text>
          </g>
          <g id="Report titles_17">
            <rect width={143} height={20} transform="translate(887 601)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_17"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="-0.02em"
            >
              <tspan x={887.416} y={615.086}>
                Binds to (moderate a
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <rect width={114} height={20} transform="translate(1013 674)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_18"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="-0.02em"
            >
              <tspan x={1013.42} y={688.086}>
                Binds to (high affin
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <rect width={127} height={28} transform="translate(489 822)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_19"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={489.297} y={841.448}>
                Androstanedione
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <rect width={59} height={28} transform="translate(971 445)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_20"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={971.438} y={464.464}>
                DHEA-S
              </tspan>
            </text>
          </g>
          <g id="gene-HSD3B1" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M481 345C481 342.791 482.791 341 485 341H577C579.209 341 581 342.791 581 345V373C581 375.209 579.209 377 577 377H485C482.791 377 481 375.209 481 373V345Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={503.742} y={364.448}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_3"
                d="M591.748 337.406V339.824L587.818 339.695L590.064 342.934L587.861 344.23L585.874 340.731L583.887 344.23L581.684 342.934L583.93 339.695L580 339.824L580 337.406L583.93 337.535L581.684 334.296L583.887 333L585.874 336.499L587.861 333L590.064 334.296L587.818 337.535L591.748 337.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1"
              groupId="gene-snps"
              genePalette={hsd3b1}
              startX={489}
              startY={379}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M284 348C284 345.791 285.791 344 288 344H380C382.209 344 384 345.791 384 348V376C384 378.209 382.209 380 380 380H288C285.791 380 284 378.209 284 376V348Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={304.742} y={367.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1"
              groupId="gene-snps_2"
              genePalette={cyp17a1}
              startX={292}
              startY={382}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_2" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M368 521C368 518.791 369.791 517 372 517H464C466.209 517 468 518.791 468 521V549C468 551.209 466.209 553 464 553H372C369.791 553 368 551.209 368 549V521Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={388.742} y={540.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-2"
              groupId="gene-snps_3"
              genePalette={cyp17a1}
              startX={376}
              startY={555}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP19A1" {...geneGroupProps("CYP19A1", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M368 894C368 891.791 369.791 890 372 890H464C466.209 890 468 891.791 468 894V922C468 924.209 466.209 926 464 926H372C369.791 926 368 924.209 368 922V894Z"
                fill={cyp19a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={388.281} y={913.448}>
                  CYP19A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp19a1"
              groupId="gene-snps_4"
              genePalette={cyp19a1}
              startX={376}
              startY={928}
              snpCount={getGeneSnpCount("CYP19A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP19A1_2" {...geneGroupProps("CYP19A1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M960 862C960 859.791 961.791 858 964 858H1056C1058.21 858 1060 859.791 1060 862V890C1060 892.209 1058.21 894 1056 894H964C961.791 894 960 892.209 960 890V862Z"
                fill={cyp19a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={980.281} y={881.448}>
                  CYP19A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp19a1-2"
              groupId="gene-snps_5"
              genePalette={cyp19a1}
              startX={968}
              startY={896}
              snpCount={getGeneSnpCount("CYP19A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SHBG" {...geneGroupProps("SHBG", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M1084 755C1084 752.791 1085.79 751 1088 751H1180C1182.21 751 1184 752.791 1184 755V783C1184 785.209 1182.21 787 1180 787H1088C1085.79 787 1084 785.209 1084 783V755Z"
                fill={shbg.lozengeFill}
              />
              <text
                id="gene-lozenge-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={1112.79} y={774.448}>
                  SHBG
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="shbg"
              groupId="gene-snps_6"
              genePalette={shbg}
              startX={1092}
              startY={789}
              snpCount={getGeneSnpCount("SHBG", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AR" {...geneGroupProps("AR", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M1418 755C1418 752.791 1419.79 751 1422 751H1514C1516.21 751 1518 752.791 1518 755V783C1518 785.209 1516.21 787 1514 787H1422C1419.79 787 1418 785.209 1418 783V755Z"
                fill={ar.lozengeFill}
              />
              <text
                id="gene-lozenge-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={1457.97} y={774.448}>
                  AR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ar"
              groupId="gene-snps_7"
              genePalette={ar}
              startX={1426}
              startY={789}
              snpCount={getGeneSnpCount("AR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD3B1_2" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M604 505C604 502.791 605.791 501 608 501H700C702.209 501 704 502.791 704 505V533C704 535.209 702.209 537 700 537H608C605.791 537 604 535.209 604 533V505Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={626.742} y={524.448}>
                  HSD3B1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="hsd3b1-2"
              groupId="gene-snps_8"
              genePalette={hsd3b1}
              startX={612}
              startY={539}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_3" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M762 366C762 363.791 763.791 362 766 362H858C860.209 362 862 363.791 862 366V394C862 396.209 860.209 398 858 398H766C763.791 398 762 396.209 762 394V366Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={782.742} y={385.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-3"
              groupId="gene-snps_9"
              genePalette={cyp17a1}
              startX={770}
              startY={400}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M762 677C762 674.791 763.791 673 766 673H858C860.209 673 862 674.791 862 677V705C862 707.209 860.209 709 858 709H766C763.791 709 762 707.209 762 705V677Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={785.039} y={696.448}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1"
              groupId="gene-snps_10"
              genePalette={srd5a1}
              startX={770}
              startY={711}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1_2" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M506 677C506 674.791 507.791 673 510 673H602C604.209 673 606 674.791 606 677V705C606 707.209 604.209 709 602 709H510C507.791 709 506 707.209 506 705V677Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={529.039} y={696.448}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1-2"
              groupId="gene-snps_11"
              genePalette={srd5a1}
              startX={514}
              startY={711}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A2" {...geneGroupProps("SRD5A2", onGeneClick)}>
            <g id="gene-lozenge_16">
              <path
                d="M762 737C762 734.791 763.791 733 766 733H858C860.209 733 862 734.791 862 737V765C862 767.209 860.209 769 858 769H766C763.791 769 762 767.209 762 765V737Z"
                fill={srd5a2.lozengeFill}
              />
              <text
                id="gene-lozenge-label_12"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={783.234} y={756.448}>
                  SRD5A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a2"
              groupId="gene-snps_12"
              genePalette={srd5a2}
              startX={770}
              startY={771}
              snpCount={getGeneSnpCount("SRD5A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UGT2B15" {...geneGroupProps("UGT2B15", onGeneClick)}>
            <g id="gene-lozenge_17">
              <path
                d="M762 934C762 931.791 763.791 930 766 930H858C860.209 930 862 931.791 862 934V962C862 964.209 860.209 966 858 966H766C763.791 966 762 964.209 762 962V934Z"
                fill={ugt2b15.lozengeFill}
              />
              <text
                id="gene-lozenge-label_13"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={780.578} y={953.448}>
                  UGT2B15
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ugt2b15"
              groupId="gene-snps_13"
              genePalette={ugt2b15}
              startX={770}
              startY={968}
              snpCount={getGeneSnpCount("UGT2B15", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A2_2" {...geneGroupProps("SRD5A2", onGeneClick)}>
            <g id="gene-lozenge_18">
              <path
                d="M506 737C506 734.791 507.791 733 510 733H602C604.209 733 606 734.791 606 737V765C606 767.209 604.209 769 602 769H510C507.791 769 506 767.209 506 765V737Z"
                fill={srd5a2.lozengeFill}
              />
              <text
                id="gene-lozenge-label_14"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={527.234} y={756.448}>
                  SRD5A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a2-2"
              groupId="gene-snps_14"
              genePalette={srd5a2}
              startX={514}
              startY={771}
              snpCount={getGeneSnpCount("SRD5A2", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgEndocrineAndrogensDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1540}
    height={895}
    viewBox="0 204 1540 895"
    fill="none"
    {...props}
  >
    <EndocrineAndrogensDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_224294">
        <rect width={1540} height={1099} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_224294">
        <rect width={1540} height={895} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEndocrineAndrogensDiagram;
